exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.steps[data-v-591f4579],\r\n.links[data-v-591f4579] {\r\n  display: -ms-grid;\r\n  display: grid;\n}\n.steps[data-v-591f4579] {\r\n  gap: 32px;\r\n  margin-bottom: 32px;\n}\n.links[data-v-591f4579] {\r\n  gap: 15px;\n}\n.link[data-v-591f4579]{\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: rgba(44, 97, 213, 1);\n}\n.step > h3[data-v-591f4579] {\r\n  font-weight: 600;\r\n  padding: 0;\r\n  margin-bottom: 15px;\n}\n.step > p[data-v-591f4579] {\r\n  margin: 0;\n}\n.page_single[data-v-591f4579]{\r\n    padding-bottom: 24px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-591f4579","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/referral-program/how-it-works.vue
// module id = 592
// module chunks = 0